// extracted by mini-css-extract-plugin
export var changeIcon = "_5k-4";
export var container = "_5k-0";
export var divider = "_5k-7";
export var externalLinkIcon = "_5k-1";
export var green = "_5k-5";
export var helpCircleIcon = "_5k-3";
export var iconButton = "_5k-2";
export var red = "_5k-6";